export default __webpack_public_path__ + "static/assets/36752e91ff2929224fcfc3a502410335.svg";